import React from 'react';

const getShadowConfig = (strength) => {
  switch (strength) {
    case 'shallow':
      return {
        layers: [
          { blur: 1.2, offset: 4, intensity: 1.2 },
          { blur: 1.2, offset: 8, intensity: 1.2 },
        ]
      };
    case 'deep':
      return {
        layers: [
          { blur: 1.2, offset: 4, intensity: 1.2 },
          { blur: 1.2, offset: 8, intensity: 1.2 },
          { blur: 1.2, offset: 12, intensity: 1.2 },
          { blur: 1.2, offset: 16, intensity: 1.2 },
        ]
      };
    case 'standard':
    default:
      return {
        layers: [
          { blur: 1.2, offset: 4, intensity: 1.2 },
          { blur: 1.2, offset: 8, intensity: 1.2 },
          { blur: 1.2, offset: 12, intensity: 1.2 },
        ]
      };
  }
};

const OuterShadowFilter = ({ id, shadowColor, strength = 'standard' }) => {
  const config = getShadowConfig(strength);

  return (
    <filter id={id} x="-50%" y="-50%" width="200%" height="200%">
      {config.layers.map((layer, index) => (
        <React.Fragment key={index}>
          <feGaussianBlur 
            in="SourceAlpha"
            stdDeviation={layer.blur}
            result={`blur_${index}`}
          />
          <feOffset dy={layer.offset} dx="0" result={`offset_${index}`}/>
          <feComposite 
            in={`offset_${index}`}
            in2="SourceAlpha" 
            operator="out" 
            result={`shadow_${index}`}
          />
          <feFlood floodColor={shadowColor} floodOpacity={layer.intensity}/>
          <feComposite 
            in2={`shadow_${index}`}
            operator="in"
            result={`coloredShadow_${index}`}
          />
          <feMerge>
            <feMergeNode in={`coloredShadow_${index}`}/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </React.Fragment>
      ))}
    </filter>
  );
};

export default OuterShadowFilter; 